import { useGlobalOrgTags } from '@/feature/tags/hooks'
import { useTagsStore } from '@/feature/tags/store'

import { TagsPopoutView } from '../TagsPopoutView/TagsPopoutView.component'

export const AlertTagsPopout = () => {
  const {
    isAlertTagsPopoutOpen,
    alertTagsPopoverPosition,
    closeAlertTagsPopout,
    globalOrgTags,
    alertTags,
    setAlertTags,
  } = useTagsStore()

  // Fetched here rather than in the alert form: this component only mounts for a
  // taggable alert with the assetTags flag on, so the tag list is never
  // requested for orgs that cannot use it.
  useGlobalOrgTags()

  return (
    <TagsPopoutView
      popoverPosition={alertTagsPopoverPosition}
      closeTagsPopout={closeAlertTagsPopout}
      isTagsPopoutOpen={isAlertTagsPopoutOpen}
      tagsForSelection={globalOrgTags}
      storedTags={alertTags}
      setStoredTags={setAlertTags}
    />
  )
}
